(function () {
  var init = function () {
    var root = document.getElementById('clarity-editorial');
    if (!root) return;

    root.querySelectorAll('.te-cta').forEach(function (cta) {
      if (!cta.getAttribute('aria-label')) {
        cta.setAttribute('aria-label', cta.textContent.trim());
      }
    });

    var sticky = root.querySelector('[data-te-mobile-sticky]');
    if (!sticky) return;

    var toggleSticky = function () {
      if (window.innerWidth > 900) {
        sticky.classList.remove('is-visible');
        return;
      }
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var scrollProgress = scrollable > 0 ? window.scrollY / scrollable : 0;
      sticky.classList.toggle('is-visible', scrollProgress >= 0);
    };

    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
    toggleSticky();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
